export const spinnerPositionMapping = {
    bottom: {
        container: { flexDirection: 'column' }
    },
    left: {
        container: { flexDirection: 'row-reverse' }
    },
    right: {
        container: { flexDirection: 'row' }
    },
    top: {
        container: { flexDirection: 'column-reverse' }
    }
};
export const spinnerSpeedMapping = {
    slow: '1s',
    normal: '0.9s',
    fast: '0.8s'
};
